module.exports = __webpack_public_path__ + "img/team5.190bde8e.jpg";